// extracted by mini-css-extract-plugin
export default {"root":"Vd6aQZ","srOnly":"mHZSwn"};